import React from 'react';
import PropTypes from 'prop-types';
import './Button.scss';

export default function Button(props) {
  if (!props.show()) {
    return null;
  }

  if (
    ![
      'primary',
      'secondary',
      'success',
      'danger',
      'warning',
      'info',
      'light',
      'dark',
      'link'
    ].includes(props.color)
  ) {
    return null;
  }

  const classes = props.customClasses
    ? props.customClasses
    : `btn btn-${props.color} btn-${props.btnSize} btn-${props.btnBlock} `;

  return (
    <button
      type={props.type}
      className={classes}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.label}
    </button>
  );
}

Button.propTypes = {
  type: PropTypes.string,
  show: PropTypes.func,
  className: PropTypes.string,
  onClick: PropTypes.func,
  label: PropTypes.string,
  disabled: PropTypes.bool
};

Button.defaultProps = {
  type: 'primary',
  show: () => true,
  className: '',
  onClick: () => {},
  label: 'button'
};
